import { MenulayoutsPage } from '../menulayouts/menulayouts';
import { Component, ViewChild } from '@angular/core';
import { NavController, LoadingController, ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Broadcaster } from '../../app/broadcaster';;
import { AlertController } from 'ionic-angular';
import { CustomModalComponent } from '../../components/custom-modal/custom-modal';

import { ApiService } from '../../app/services/api.service';
import { Config } from '../../app/app.config';
import { Localization } from '../../app/app.localization'
import { OkageGoGoogleAnalyticsProvider } from '../../providers/okage-go-google-analytics/okage-go-google-analytics';

@Component({
  selector: 'page-order-history',
  templateUrl: 'order-history.html',
  providers: [ApiService]
})

export class OrderHistoryPage {
  @ViewChild('paymentForm') paymentForm: any;
  @ViewChild('paygentForm') paygentForm: any;
  @ViewChild('okagepayForm') okagepayForm: any;

  confs: any;
  orderArray = [];
  totalAmount = 0;
  totalCount = 0;
  iFoods: Array<Array<number>>;
  iTotal: number;
  loading: any;

  visitor: any;
  voucher: any;
  build_as_takeout: any;
  selfpay_url: any;
  paygentpayment: any;
  okagepaypayment:any;
  gmopayment: any;
  shopId: any;
  gmolink: any;
  isEnabledShowButton: boolean = false;
  disableInstorePayment: boolean = false;

  constructor(public navCtrl: NavController,
    private storage: Storage,
    private alertCtrl: AlertController,
    private broadcaster: Broadcaster,
    private _apiService: ApiService,
    private _loc: Localization,
    public modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private _ga: OkageGoGoogleAnalyticsProvider,
    /*public http: Http*/) {
    this.build_as_takeout = Config.build_as_takeout;
    this.confs = JSON.parse(localStorage.getItem("configs"));
    this.selfpay_url = (this.confs.INSTORESELF_SELFPAY_URL && this.confs.INSTORESELF_SELFPAY_URL.length > 0)
    ? this.confs.INSTORESELF_SELFPAY_URL
    : "";

    // 強制的に店内セルフ & Payのボタンを非表示にする
    if (this.confs["INSTORE_PAYMENT_DISABLE_URL"] && this.confs["INSTORE_PAYMENT_DISABLE_URL"].length) {
      try {
        let disable_urls = JSON.parse(this.confs["INSTORE_PAYMENT_DISABLE_URL"]);
        disable_urls.forEach(disable_url => {
          if (document.location.href.indexOf(disable_url) >= 0) this.disableInstorePayment = true;
        });
      } catch(e) {
        this.disableInstorePayment = false;
      }
    }

    console.log(this.selfpay_url);
    this.foodCounterChanged();
    this.broadcaster.on<number>('foodCounterChanged')
      .subscribe(from => {
        this.foodCounterChanged();
      });
    if (!this.build_as_takeout) this.setPaymentType();
    }

  ionViewWillEnter() {
    if (!Config.build_as_takeout) this._ga.orderHistoryPageView();
    
    if (Config.deferred) {
      let table_id = parseInt(localStorage.getItem("table_id"), 0);
      if (!table_id || table_id < 1) {
        let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('システムエラー'), subTitle: this._loc.t('エラーが発生しました。\nmissing table_id. need realod url'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
        modal.present();
        return;
      }
      this._apiService.getSingleTableOccupation(table_id).subscribe(
        (result) => {
          if (result.result && result.result.length > 0 && result.result[0].visitor_id && result.result[0].visitor_id > 0) {
            this.historyChanged(parseInt(result.result[0].visitor_id, 0));
          } else {
            let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('注文エラー'), subTitle: this._loc.t('現在はオーダー履歴の閲覧ができません\n未着席状態'), bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
            modal.present();
          }
        }
      );
      return;
    }

    this.historyChanged();
  }

  foodCounterChanged() {
    this.iFoods = [];
    this.iTotal = 0;
    this.storage.get('foods.selected').then((v) => {
      if (v) {
        this.iFoods = v;
      }
      this.countTotal();
    });
  }

  historyChanged(visitor_id = 0) {
    if (visitor_id < 1) visitor_id = parseInt(localStorage.getItem("visitor_id"), 0);
    this.storage.get('history').then((h) => {
      let hjson = {
        visitor_id: visitor_id,
        uiid: Config.uiid,
      };
      this.loading = this.loadingCtrl.create();
      this.loading.present();
      // 店外
      if (Config.build_as_takeout) {
        // 予約
        if (localStorage.getItem("reserved") == "1") {
          console.log("getLastReservedOrderWithDeleted");
          this._apiService.getLastReservedOrderWithDeleted(hjson).subscribe(
            (result) => {
              this.loading.dismiss();
              this.storage.set('horder.last', result);
              console.log(result);
              if (typeof result.result !== 'undefined') {
                this.orderArray = this.makeOrderArray(result);
                this.calculateTotalAmount();
                this.calculateTotalCount();
              }
            }, (error) => {
              console.log(error);
              this.loading.dismiss();
            });
        } else {
          this._apiService.getLastOrderWithDeleted(hjson).subscribe(
          (result) => {
            this.loading.dismiss();
            this.storage.set('horder.last', result);
            if (typeof result.result !== 'undefined') {
              this.orderArray = this.makeOrderArray(result);
              this.calculateTotalAmount();
              this.calculateTotalCount();
            }
          }, (error) => {
            console.log(error);
            this.loading.dismiss();
          });
        }
      } else { // 店内
        this._apiService.getLastOrder(hjson, this._loc.loc).subscribe(
          (result) => {
            this.loading.dismiss();
            this.storage.set('horder.last', result);
            if (typeof result.result !== 'undefined') {
              this.orderArray = this.makeOrderArray(result, true);
              this.calculateTotalAmount();
              this.calculateTotalCount();
            }
          }, (error) => {
            console.log(error);
            this.loading.dismiss();
          });
      }
    });
  }

  makeOrderArray(result, reverse = false) {
    result.result.sort(function (a, b) {
      return a.order_id - b.order_id;
    });
    let temp_orderArray = [];
    let chargeData = new Object();
    for (var i = 0; i < result.result.length; i++) {
      // 親メニュー
      if (result.result[i].quantity > 0 && result.result[i].parent_menu_id == 0 && result.result[i].menu_id !== this.confs['MOBILEORDER_DELIVERY_CHARGE_MENU_ID']) {
        let parent_amount = result.result[i].price;
        let sub_menu = [];
        for (var j = i+1; j < result.result.length; j++) {
          if (result.result[j].parent_menu_id == 0) break;
          if (result.result[j].quantity > 0) {
            sub_menu.push({
              order_id: result.result[j].order_id,
              order_no: result.result[j].order_no,
              id: result.result[j].menu_id,
              name: (result.result[j].menu_full_name) ? result.result[j].menu_full_name : result.result[j].menu_name,
              parent_menu_id: result.result[j].parent_menu_id,
              quantity: (result.result[j].quantity / result.result[i].quantity),
              price: result.result[j].price,
              order_datetime: result.result[j].order_datetime,
              as_topping: result.result[j].as_topping,
              requried: result.result[j].required,
            });
            parent_amount += ((result.result[j].quantity/result.result[i].quantity) * result.result[j].price);
          }
        }
        temp_orderArray.push({
          order_no: result.result[i].order_no,
          id: result.result[i].menu_id,
          name: (result.result[i].menu_full_name) ? result.result[i].menu_full_name : result.result[i].menu_name,
          parent_menu_id: result.result[i].parent_menu_id,
          quantity: result.result[i].quantity,
          price: result.result[i].price,
          order_datetime: result.result[i].order_datetime,
          parent_amount: (parent_amount / result.result[i].quantity),
          requried: result.result[i].required,
          sub_menu: sub_menu
        });
      } else if (result.result[i].quantity > 0 && result.result[i].menu_id === this.confs['MOBILEORDER_DELIVERY_CHARGE_MENU_ID']) { // 配送料は別に格納
        chargeData = {
          order_no: result.result[i].order_no,
          id: result.result[i].menu_id,
          name: (result.result[i].menu_full_name) ? result.result[i].menu_full_name : result.result[i].menu_name,
          parent_menu_id: result.result[i].parent_menu_id,
          quantity: result.result[i].quantity,
          price: result.result[i].price,
          order_datetime: result.result[i].order_datetime,
          parent_amount: (result.result[i].price / result.result[i].quantity),
          sub_menu: []
        };
      }
    }
    // 注文メニューの一番最後に配送料を追加
    if(Object.keys(chargeData).length > 0) {
      temp_orderArray.push(chargeData);
    }
    if (reverse) temp_orderArray.reverse();
    return temp_orderArray;
  }

  countTotal() {
    var total = 0;
    for (var i = 0; i < 3; i++) {
      if (this.iFoods[i]) {
        for (var j = 0; j < this.iFoods[i].length; j++) {
          if (this.iFoods[i][j]) {
            total += this.iFoods[i][j];
          }
        }
      }
    }
    this.iTotal = total;
    this.storage.set('iTotal', this.iTotal);
  }

  calculateTotalAmount() {
    this.totalAmount = 0;
    this.orderArray.forEach(element => {
      this.totalAmount += (element.quantity * element.price);
      element.sub_menu.forEach(subelement => {
        this.totalAmount += (element.quantity * subelement.quantity * subelement.price);
      });
    });
  }

  calculateTotalCount() {
    this.totalCount = 0;
    this.orderArray.forEach(element => {
      if (element.parent_menu_id == "0" && element.id !== this.confs['MOBILEORDER_DELIVERY_CHARGE_MENU_ID']) {
        this.totalCount += (element.quantity * 1)
      }
    });
  }

  priceString(price) {
    var newPrice;
    newPrice = String(price).split('.');
    newPrice[0] = newPrice[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return newPrice.join('.');
  }

  clickDecrease(item) {
    this.orderArray.forEach(element => {
      if (element.id == item.id) {
        if (element.quantity > 0) {
          element.quantity -= 1;
        }
      }
    });

    this.calculateTotalAmount()
  }

  clickPurchase() {
    if (window.confirm("本当にお会計に進んでもよろしいですか？")) {
      console.log("tap purchase");
      this.broadcaster.broadcast('request.purchase');
    }
  }

  clickIncrease(item) {
    this.orderArray.forEach(element => {
      if (element.id == item.id) {
        element.quantity += 1;
      }
    });

    this.calculateTotalAmount()
  }

  countDecimals(number) {
    var str = "" + number;
    var index = str.indexOf('.');
    if (index >= 0) {
      return str.length - index - 1;
    } else {
      return 0;
    }
  }

  sendOrder() {
    this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
  }

  historyOrder(order) {
    localStorage.setItem("orderHistory", JSON.stringify(order));
    let conf = JSON.parse(localStorage.getItem("configs"));
    if (conf["MOBILEORDER_FIXED_LAYOUT"] && parseInt(conf["MOBILEORDER_FIXED_LAYOUT"]) > 0) {
      localStorage.setItem('returnHistory', '1');
      this.navCtrl.parent.select(Config.tab_menu_number.menulistpage);
    } else {
      this.navCtrl.parent.select(Config.tab_menu_number.menulayoutspage);
    }
  }

  setPaymentType() {
    let storeConfig  = JSON.parse(localStorage.getItem("configs"));
    let configPaymentModule = storeConfig['MOBILEORDER_PAYMENT_MODULE'];
    let beforeValues = [];

    if (configPaymentModule != undefined && configPaymentModule && configPaymentModule.includes('payment_modules')) {
      let jsonPaymentModule = JSON.parse(configPaymentModule);

      jsonPaymentModule.payment_modules.map(function(value) { // 支払いタイプの値がobjectの場合
        if (value['method'] === 'before') {
          beforeValues.push(value['type']);
        }
      })

      // method:beforeが一つの場合は会計ボタンを表示し、値をセットする
      if (beforeValues.length === 1) {
        localStorage.setItem('paymentType', beforeValues[0]);
        this.isEnabledShowButton = true;
      }

    } else if (configPaymentModule === 'nopayment') { // nopaymentは会計ボタンを表示しない
      this.isEnabledShowButton = false;
    } else { // string
      if (configPaymentModule != undefined) {
        localStorage.setItem('paymentType', configPaymentModule);
        this.isEnabledShowButton = true;
      }
    }
  }

  
  clickMobilePay(){
    // link to mobilepay
    const payConfirmModal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('会計に進む'), subTitle: (this.confs["INSTORE_PAYMENT_ALERT_MESSAGE"] && this.confs["INSTORE_PAYMENT_ALERT_MESSAGE"].length > 0) ? this.confs["INSTORE_PAYMENT_ALERT_MESSAGE"] : this._loc.t('クレジットカードの支払いに進みます。\n会計に進むと5分間は追加の注文、\n別の支払いの選択ができなくなります。\n会計に進みますか？'), bottomOkCancel:true }, { showBackdrop: false, enableBackdropDismiss: false });
      payConfirmModal.onDidDismiss(data => {
        if (data) {
          let visitor_id = localStorage.getItem("visitor_id");
          this._apiService.getPaymentRequest({ "visitor_id": visitor_id, "store_id": localStorage.getItem("store_id"), "uiid": Config.uiid, "version": "2.5.1", "payment_type": localStorage.getItem("paymentType") }).subscribe(
            (result) => {
              if (!result.status || parseInt(result.status, 0) !== 1000) {
                this.loading.dismiss();
                let message = (result.error_message) ? result.error_message : this._loc.t("エラーが発生しました");

                let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('エラー'), subTitle: message, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
                modal.present();
              }
              else if (result.type && result.type == "paygent") {
                // paygent
                localStorage.setItem("visitor_id", visitor_id);
                this.paygentpayment = {
                  endpoint: result.endpoint,
                  request: result.request
                };
                setTimeout(function () {
                  console.log(this.paygentForm);
                  this.paygentForm.paygentpayment = this.paygentpayment;
                  setTimeout(function () {
                    this.loading.dismiss();
                    this.paygentForm.submit();
                  }.bind(this), 300);
                }.bind(this), 300);
              }
              else if (result.type && result.type == "okagepay") {
                // okagepay
                localStorage.setItem("visitor_id", visitor_id);
                this.okagepaypayment = {
                  endpoint:result.endpoint,
                  request:result.request
                };
                setTimeout(function(){
                  console.log(this.okagepayForm);
                  this.okagepayForm.okagepaypayment = this.okagepaypayment;
                  setTimeout(function(){
                    this.loading.dismiss();
                    this.preventSubmit = true;
                    this.okagepayForm.submit();
                  }.bind(this), 300);
                }.bind(this), 300);
              } else {
                // gmo
                localStorage.setItem("visitor_id", result.request.ClientField3);
                this.gmopayment = result.request;
                this.gmopayment.endpoint = result.endpoint;
                this.shopId = result.request.ShopID;
                this.gmolink = this._apiService.getGmolink();
                if (result.endpoint){
                  this.gmolink = result.endpoint;
                }

                setTimeout(function () {
                  this.paymentForm.gmopayment = this.gmopayment;
                  setTimeout(function () {
                    this.loading.dismiss();
                    this.paymentForm.submit();
                  }.bind(this), 300);
                }.bind(this), 300);
              }
            }
          );
          
        }
      });
      payConfirmModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/order-history/order-history.ts